export enum UserStatus {
  New = 'new',
  Moderation = 'moderation',
  Declined = 'declined',
  Approved = 'approved',
}
